/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import cn from 'classnames';

import { navigate } from '@reach/router';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    outline: 'none',
  },
  item: {
    fontSize: '14px',
    fontFamily: 'Raleway',
    color: '#2a149a',
    '&:hover': {
      backgroundColor: 'rgba(42, 20, 154, 0.08)',
    },
  },
});

const RichMenuItem = ({ classes, className, name, url, submenu }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMouseOver = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = () => {
    navigate(url);
    setAnchorEl(null);
  };

  const rootClassName = cn(classes.root, className);

  return (
    <>
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onMouseOver={handleMouseOver}
        onFocus={handleMouseOver}
        className={rootClassName}
      >
        {name}
        <ExpandMoreIcon />
      </div>
      <Popper open={open} anchorEl={anchorEl} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            id="menu-list-grow"
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList>
                  {submenu.map(option => (
                    <MenuItem
                      key={`sub-menu-item-${option.name}`}
                      //selected={option === 'Pyxis'}
                      onClick={() => {
                        navigate(option.url);
                      }}
                      className={classes.item}
                    >
                      {option.name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
};

export default withStyles(styles)(RichMenuItem);
